import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "This summer a bunch of hackers might realize your crazy idea",
  "description": "",
  "published": "2010-06-18T00:00:00.000Z",
  "redirect_from": ["/blog/this-summer-a-bunch-of-hackers-might-realize-your-crazy-idea/swizec/1365"],
  "categories": "Hacker (hobbyist), Hacking, IPad, Uncategorized",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <ul>
      <li parentName="ul">
        <p parentName="li"><a parentName="p" {...{
            "href": "http://www.flickr.com/photos/10177557@N08/4449940571"
          }}><img parentName="a" {...{
              "src": "https://swizec.com/blog/wp-content/uploads/2010/06/4449940571_0e57af61b0_m.jpg",
              "alt": "totaly insane crazy shit",
              "title": "totaly insane crazy shit"
            }}></img></a></p>
        <p parentName="li">{`Image by `}<a parentName="p" {...{
            "href": "http://www.flickr.com/photos/10177557@N08/4449940571"
          }}>{`Wollbinho`}</a>{` via Flickr`}</p>
      </li>
    </ul>
    <p>{`A local hackerspace I'm a part of is organizing a summer long hackday that's starting in a few weeks.`}</p>
    <p>{`What we need right now are `}<a parentName="p" {...{
        "href": "http://summer.hekovnik.si/ideas-and-projects/"
      }}>{`the crazies, most whackiest and twoplus insane ideas`}</a>{` you can possibly think of. And pimp 'em out, get votes!`}</p>
    <p>{`When the hacking carnage begins the highest voted ideas will be gathered up and teams will start working on them. You are also welcome to come put your arse where your mouth is and help make the idea happen, just so you know.`}</p>
    <p>{`Then, when the carnage is over, there will be a demoday. Each team will present their idea in front of a bunch of business people and the likes, although personally I'm all for making them public and creating a huge party where everyone is invited. Hell, a barcamp. Hmm ... yeah, I'll convince everyone that that's the way it should be done.`}</p>
    <p>{`Anyhow, the demo day, then whomever is the best gets heaps upon heaps upon shitloads of bragging rights. They have essentially just become the awesomest dudes in the whole of Europe. That's right, if you're too much of a pussy to even participate in this thing you're a de facto loser. Turn in your hacking license at once. You aren't worthy of calling yourself a hacker.`}</p>
    <p>{`Also, while you're reading this, why not go ahead and vote for the three ideas I contributed :P`}</p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://summerinabasement.uservoice.com/forums/59903-ideas-and-projects/suggestions/835095-web-cheaper-than-beowulf-cluster?ref=title"
        }}>{`Cheaper-than-beowulf cluster`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://summerinabasement.uservoice.com/forums/59903-ideas-and-projects/suggestions/834765-mobile-smart-ipad-rss-reader?ref=title"
        }}>{`Smart RSS reader for iPad`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://summerinabasement.uservoice.com/forums/59903-ideas-and-projects/suggestions/841441-mobile-web-mood-music?ref=title"
        }}>{`Mood music`}</a></li>
    </ul>
    <p>{`Oh and do pass this around, the more crazy ideas people contribute the merrier :)`}</p>
    <p><a parentName="p" {...{
        "href": "http://www.zemanta.com/",
        "title": "Enhanced by Zemanta"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/zemified_e.png?x-id=e0a5ac72-c0d8-450c-bbdd-aea80e892dfd",
          "alt": "Enhanced by Zemanta"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      